"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Icon = require("../js/Icon");

var _Icon2 = _interopRequireDefault(_Icon);

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var WrappedIcon = function WrappedIcon(props) {
  return _react2.default.createElement(
    _Icon2.default,
    props,
    _react2.default.createElement(
      "svg",
      { className: "spectrum-UIIcon-ChevronLeftLarge" },
      _react2.default.createElement("path", { d: "M9.605 13.843L3.551 8l6.056-5.84A1.25 1.25 0 0 0 8.74.01a1.237 1.237 0 0 0-.864.353L.882 7.1a1.244 1.244 0 0 0 0 1.8l6.988 6.742a1.248 1.248 0 1 0 1.732-1.8z", className: "spectrum-UIIcon--medium" }),
      _react2.default.createElement("path", { d: "M12.109 17.853L4.043 10l8.066-7.839a1.242 1.242 0 0 0 .381-.894 1.24 1.24 0 0 0-2.119-.891L1.378 9.108a1.245 1.245 0 0 0 0 1.79l8.99 8.744a1.247 1.247 0 1 0 1.738-1.789z", className: "spectrum-UIIcon--large" })
    )
  );
};

WrappedIcon.displayName = 'ChevronLeftLarge';
exports.default = WrappedIcon;

